import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import it from './locales/it.json';
import de from './locales/de.json';
import es from './locales/es.json';
import zh from './locales/zh.json';
import fr from './locales/fr.json';

i18n
	.use(LanguageDetector)
	.use(initReactI18next)
	.init({
		resources: {
			it: { translation: it },
			de: { translation: de },
			es: { translation: es },
			zh: { translation: zh },
			fr: { translation: fr },
		},
		fallbackLng: 'it',
		interpolation: {
			escapeValue: false,
		},
		detection: {
			order: ['localStorage', 'navigator'],
			caches: ['localStorage'],
		},
		react: {
			useSuspense: false,
		},
	});

export default i18n;
